// removed by extract-text-webpack-plugin
module.exports = {"block":"MainMenuSet__block-1k4re","title":"MainMenuSet__title-zn5p_"};